import { ContainWordsContainer } from '../../containers/advancedFilters/ContainWordsContainer';
import { IFilter } from '../../types/advancedFilters';

export const containWords: IFilter = {
  component: ContainWordsContainer,
};
